import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { storeNames } from './config/config.type.ts';

const initialState = {
  devicesConnectionState: {},
  ledTurnedOnState: {},
};

interface SensorLedStateStorage {
  devicesConnectionState: Record<string, boolean>;
  ledTurnedOnState: Record<string, boolean>;
  updateDevicesConnectionState: (sensorId: string, isConnected: boolean) => void;
  updateLedsOnState: (ledId: string, isConnected: boolean) => void;
}

export const useSensorLedStateStorage = create(
  persist<SensorLedStateStorage>(
    set => ({
      ...initialState,
      updateLedsOnState: (ledId: string, isOn: boolean) =>
        set((state: SensorLedStateStorage) => {
          if (isOn === undefined) {
            return state;
          }

          return {
            ...state,
            ledTurnedOnState: {
              ...state.ledTurnedOnState,

              [ledId]: isOn,
            },
          };
        }),
      updateDevicesConnectionState: (sensorId: string, isConnected: boolean) =>
        set((state: SensorLedStateStorage) => {
          if (isConnected === undefined) {
            return state;
          }

          return {
            ...state,
            devicesConnectionState: {
              ...state.devicesConnectionState,
              [sensorId]: isConnected,
            },
          };
        }),
    }),
    {
      name: storeNames.sensorLed,
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
